import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BlockTabs from '../../BlockTabs';
import { Loader } from '../../components';
import ConsentByDayTable from "./ConsentByDayTable";
import ConsentByDayChart from "./ConsentByDayChart";
import CumulatedConsentByDayChart from "./CumulatedConsentByDayChart";

const TableContainer = ({data}) => {

  const dataToTableRow = (el) => ({
    ...el,
    presentationRate: (el.devices || 0) > 0 ? el.devicesWithCmpPresented/el.devices : 0,
    consentRate: (el.devicesWithCmpPresented || 0) > 0 ? el.consentedDevices/el.devicesWithCmpPresented : 0,
    dailyConsentRate: (el.dailyCmpPresented || 0) > 0 ? el.dailyConsents/el.dailyCmpPresented : 0
  })
  const tableData = useMemo(()=>{
    return data.map((row) => (dataToTableRow(row)))
  }, [data])

  return (
    <ConsentByDayTable data={tableData} />
  )
}

export default function ConsentDataByDay ( {data = [], isSuccess, isFetching: isLoading, refetch} ) {

  const { t } = useTranslation();
  const loaderProps = { success: (!isLoading && isSuccess), error: (!isLoading && !isSuccess), retry: refetch }
  return (
    <BlockTabs title={t("cmp.analytics.dataByDay.title")} defaultActiveKey="cumulatedChart">
      <Loader {...loaderProps} key="table" title={t("cmp.analytics.dataByDay.table")}>
        <TableContainer data={data} />
      </Loader>
      <Loader {...loaderProps} key="dailyChart" title={t("cmp.analytics.dataByDay.daily")} >
        <ConsentByDayChart data={data} />
      </Loader>
      <Loader {...loaderProps} key="cumulatedChart" title={t("cmp.analytics.dataByDay.cumulated")} >
        <CumulatedConsentByDayChart data={data} />
      </Loader>
    </BlockTabs>
  )
}
